var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{directives:[{name:"b-popover",rawName:"v-b-popover.hover",value:(_vm.tr(_vm.text)),expression:"tr(text)",modifiers:{"hover":true}}],staticClass:"e-hint fas fa-question-circle"})
}
var staticRenderFns = []

export { render, staticRenderFns }